function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
}
function isFunction(value) {
  return typeof value === 'function';
}
function isTheme(value) {
  return value == null ? void 0 : value.theme;
}
var defaultBreakpoints = /*#__PURE__*/[40, 52, 64].map(function (n) {
  return n + "em";
});
var defaultTheme = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72],
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var pseudoSelectors = {
  _hover: ['&:hover', '&[data-hover]'],
  _active: ['&:active', '&[data-active]'],
  _focus: ['&:focus', '&[data-focus]'],
  _highlighted: ['&[data-highlighted]'],
  _focusWithin: ['&:focus-within'],
  _focusVisible: ['&:focus-visible'],
  _disabled: ['&[disabled]', '&[aria-disabled=true]', '&[data-disabled]'],
  _readOnly: ['&[aria-readonly=true]', '&[readonly]', '&[data-readonly]'],
  _before: ['&::before'],
  _after: ['&::after'],
  _empty: ['&:empty'],
  _expanded: ['&[aria-expanded=true]', '&[data-expanded]'],
  _checked: ['&:checked', '&[aria-checked=true]', '&[data-checked]'],
  _grabbed: ['&[aria-grabbed=true]', '&[data-grabbed]'],
  _pressed: ['&[aria-pressed=true]', '&[data-pressed]'],
  _invalid: ['&[aria-invalid=true]', '&[data-invalid]'],
  _valid: ['&[data-valid]', '&[data-state=valid]'],
  _loading: ['&[data-loading]', '&[aria-busy=true]'],
  _selected: ['&[aria-selected=true]', '&[data-selected]'],
  _hidden: ['&[hidden]', '&[data-hidden]'],
  _even: ['&:nth-of-type(even)'],
  _odd: ['&:nth-of-type(odd)'],
  _first: ['&:first-of-type'],
  _last: ['&:last-of-type'],
  _notFirst: ['&:not(:first-of-type)'],
  _notLast: ['&:not(:last-of-type)'],
  _visited: ['&:visited'],
  _activeLink: ['&[aria-current=page]'],
  _indeterminate: ['&:indeterminate', '&[aria-checked=mixed]', '&[data-indeterminate]'],
  _placeholder: ['&::placeholder'],
  _fullScreen: ['&:fullscreen'],
  _selection: ['&::selection']
};

function get(obj, path, fallback) {
  var key = typeof path === 'string' ? path.split('.') : [path];
  if (typeof path === 'string' && (path.endsWith('rem') || path.endsWith('px'))) {
    key = [path];
  }
  var result = obj;
  for (var i = 0; i < key.length; i += 1) {
    if (!result) {
      break;
    }
    result = result[key[i]];
  }
  return result === undefined ? fallback : result;
}
function merge(a, b) {
  var result = _extends({}, a, b);
  Object.keys(result).forEach(function (key) {
    var _Object$assign;
    if (!a[key] || typeof b[key] !== 'object') {
      return;
    }
    Object.assign(result, (_Object$assign = {}, _Object$assign[key] = Object.assign(a[key], b[key]), _Object$assign));
  });
  return result;
}
function sort(obj) {
  var result = {};
  Object.keys(obj).sort(function (a, b) {
    return a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }).forEach(function (key) {
    result[key] = obj[key];
  });
  return result;
}

function createMediaQuery(n) {
  return "@media screen and (min-width: " + n + ")";
}
function parseResponsiveStyles(mediaQueries, sx, scale, raw, props) {
  var styles = {};
  raw.slice(0, mediaQueries.length).forEach(function (value, i) {
    var media = mediaQueries[i];
    var style = sx(value, scale, props);
    if (!media) {
      styles = _extends({}, styles, style);
    } else {
      var _extends2;
      styles = _extends({}, styles, (_extends2 = {}, _extends2[media] = _extends({}, styles[media], style), _extends2));
    }
  });
  return styles;
}
function parseResponsiveObject(breakpoints, sx, scale, raw, props) {
  var styles = {};
  Object.keys(raw).forEach(function (key) {
    var breakpoint = breakpoints[key];
    var value = raw[key];
    var style = sx(value, scale, props);
    if (!breakpoint) {
      styles = _extends({}, styles, style);
    } else {
      var _extends3;
      var media = createMediaQuery(breakpoint);
      styles = _extends({}, styles, (_extends3 = {}, _extends3[media] = _extends({}, styles[media], style), _extends3));
    }
  });
  return styles;
}
var createParser = function createParser(config) {
  var cache = {};
  var parser = function parser(props) {
    var _props$theme;
    var styles = {};
    var shouldSort = false;
    var isCacheDisabled = (_props$theme = props.theme) == null ? void 0 : _props$theme.disableStyledSystemCache;
    Object.keys(props).forEach(function (key) {
      if (!config[key]) {
        return;
      }
      var sx = config[key];
      var raw = props[key];
      var scale = get(props.theme, sx.scale, sx.defaults);
      if (typeof raw === 'object') {
        cache.breakpoints = !isCacheDisabled && cache.breakpoints || get(props.theme, 'breakpoints', defaultBreakpoints);
        if (Array.isArray(raw)) {
          var _cache$breakpoints;
          cache.media = !isCacheDisabled && cache.media || [null].concat(((_cache$breakpoints = cache.breakpoints) != null ? _cache$breakpoints : []).map(createMediaQuery));
          styles = merge(styles, parseResponsiveStyles(cache.media, sx, scale, raw, props));
          return;
        }
        if (raw !== null) {
          var _cache$breakpoints2;
          styles = merge(styles, parseResponsiveObject((_cache$breakpoints2 = cache.breakpoints) != null ? _cache$breakpoints2 : [], sx, scale, raw, props));
          shouldSort = true;
        }
        return;
      }
      styles = _extends({}, styles, sx(raw, scale, props));
    });
    if (shouldSort) {
      styles = sort(styles);
    }
    return styles;
  };
  parser.config = config;
  parser.propNames = Object.keys(config);
  parser.cache = cache;
  var keys = Object.keys(config).filter(function (k) {
    return !['config', 'propNames', 'cache'].includes(k);
  });
  if (keys.length > 1) {
    keys.forEach(function (key) {
      var _createParser;
      parser[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser));
    });
  }
  return parser;
};

var compose = function compose() {
  var config = {};
  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }
  parsers.forEach(function (parser) {
    if (!parser || !parser.config) {
      return;
    }
    config = _extends({}, config, parser.config);
  });
  return createParser(config);
};

function createStyleFunction(_ref) {
  var properties = _ref.properties,
    property = _ref.property,
    scale = _ref.scale,
    _ref$transform = _ref.transform,
    transform = _ref$transform === void 0 ? get : _ref$transform,
    defaultScale = _ref.defaultScale;
  var p = properties || (property ? [property] : []);
  var styleFn = function styleFn(_value, _scale, _props) {
    var result = {};
    var value = transform(_scale, _value, _value, _props);
    if (value === null) {
      return undefined;
    }
    if (Array.isArray(value) && properties.length > 1) {
      p.forEach(function (prop, index) {
        result[prop] = value[index];
      });
    } else {
      p.forEach(function (prop) {
        result[prop] = value;
      });
    }
    return result;
  };
  styleFn.properties = properties;
  styleFn.property = property;
  styleFn.scale = scale;
  styleFn.transform = transform.name !== 'get' ? transform : undefined;
  styleFn.defaults = defaultScale;
  return styleFn;
}

function system(args) {
  if (args === void 0) {
    args = {};
  }
  var config = {};
  Object.keys(args).forEach(function (key) {
    var argConfig = args[key];
    if (argConfig === false) {
      return;
    }
    // shorthand definition
    if (argConfig === true) {
      config[key] = createStyleFunction({
        property: key,
        scale: key
      });
      return;
    }
    if (typeof argConfig === 'function') {
      config[key] = argConfig;
      return;
    }
    config[key] = createStyleFunction(argConfig);
  });
  return createParser(config);
}

var config$b = {
  animation: {
    property: 'animation',
    scale: 'animation.animation'
  },
  animationName: {
    property: 'animationName',
    scale: 'animation.name'
  },
  animationDuration: {
    property: 'animationDuration',
    scale: 'animation.duration'
  },
  animationTimingFunction: {
    property: 'animationTimingFunction',
    scale: 'animation.timingFn'
  },
  animationDelay: {
    property: 'animationDelay',
    scale: 'animation.delay'
  },
  animationIterationCount: {
    property: 'animationIterationCount'
  },
  animationDirection: {
    property: 'animationDirection'
  },
  animationFillMode: {
    property: 'animationFillMode'
  },
  animationPlayState: {
    property: 'animationPlayState'
  }
};
var animation = /*#__PURE__*/system(config$b);

var config$a = {
  background: {
    property: 'background',
    scale: 'colors'
  },
  backgroundImage: {
    property: 'backgroundImage'
  },
  backgroundClip: {
    property: 'backgroundClip'
  },
  backgroundSize: {
    property: 'backgroundSize'
  },
  backgroundPosition: {
    property: 'backgroundPosition'
  },
  backgroundRepeat: {
    property: 'backgroundRepeat'
  },
  backgroundAttachment: {
    property: 'backgroundAttachment'
  }
};
config$a.bgImage = config$a.backgroundImage;
config$a.bgClip = config$a.backgroundClip;
config$a.bgSize = config$a.backgroundSize;
config$a.bgPosition = config$a.backgroundPosition;
config$a.bgRepeat = config$a.backgroundRepeat;
config$a.bgAttachment = config$a.backgroundAttachment;
var background = /*#__PURE__*/system(config$a);

var config$9 = {
  border: {
    property: 'border',
    scale: 'borders'
  },
  borderWidth: {
    property: 'borderWidth',
    scale: 'borderWidths'
  },
  borderStyle: {
    property: 'borderStyle',
    scale: 'borderStyles'
  },
  borderColor: {
    property: 'borderColor',
    scale: 'colors'
  },
  borderRadius: {
    property: 'borderRadius',
    scale: 'radii'
  },
  borderTop: {
    property: 'borderTop',
    scale: 'borders'
  },
  borderTopLeftRadius: {
    property: 'borderTopLeftRadius',
    scale: 'radii'
  },
  borderTopRightRadius: {
    property: 'borderTopRightRadius',
    scale: 'radii'
  },
  borderRight: {
    property: 'borderRight',
    scale: 'borders'
  },
  borderBottom: {
    property: 'borderBottom',
    scale: 'borders'
  },
  borderBottomLeftRadius: {
    property: 'borderBottomLeftRadius',
    scale: 'radii'
  },
  borderBottomRightRadius: {
    property: 'borderBottomRightRadius',
    scale: 'radii'
  },
  borderLeft: {
    property: 'borderLeft',
    scale: 'borders'
  },
  borderX: {
    properties: ['borderLeft', 'borderRight'],
    scale: 'borders'
  },
  borderY: {
    properties: ['borderTop', 'borderBottom'],
    scale: 'borders'
  },
  borderTopWidth: {
    property: 'borderTopWidth',
    scale: 'borderWidths'
  },
  borderTopColor: {
    property: 'borderTopColor',
    scale: 'colors'
  },
  borderTopStyle: {
    property: 'borderTopStyle',
    scale: 'borderStyles'
  },
  borderBottomWidth: {
    property: 'borderBottomWidth',
    scale: 'borderWidths'
  },
  borderBottomColor: {
    property: 'borderBottomColor',
    scale: 'colors'
  },
  borderBottomStyle: {
    property: 'borderBottomStyle',
    scale: 'borderStyles'
  },
  borderLeftWidth: {
    property: 'borderLeftWidth',
    scale: 'borderWidths'
  },
  borderLeftColor: {
    property: 'borderLeftColor',
    scale: 'colors'
  },
  borderLeftStyle: {
    property: 'borderLeftStyle',
    scale: 'borderStyles'
  },
  borderRightWidth: {
    property: 'borderRightWidth',
    scale: 'borderWidths'
  },
  borderRightColor: {
    property: 'borderRightColor',
    scale: 'colors'
  },
  borderRightStyle: {
    property: 'borderRightStyle',
    scale: 'borderStyles'
  }
};
var border = /*#__PURE__*/system(config$9);

var colourNameToHex = function colourNameToHex(colour) {
  var colours = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    gold: '#ffd700',
    goldenrod: '#daa520',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    'indianred ': '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavender: '#e6e6fa',
    lavenderblush: '#fff0f5',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2',
    lightgrey: '#d3d3d3',
    lightgreen: '#90ee90',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370d8',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#d87093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32'
  };
  if (typeof colours[colour.toLowerCase()] != 'undefined') return colours[colour.toLowerCase()];
  return null;
};
var getContrast = function getContrast(hexstring, colors) {
  // eslint-disable-next-line prefer-const
  var r, g, b;
  // Check if the hexstring is transparent.
  if (hexstring === 'transparent') {
    return 'initial';
    // Check the format of the color, HEX or RGB?
  } else if (hexstring.match(/^rgb/)) {
    // If RGB --> store the red, green, blue values in separate variables
    var color = hexstring.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
    r = color[1];
    g = color[2];
    b = color[3];
  } else if (hexstring.match(/^#/)) {
    // If hex --> Convert it to RGB: http://gist.github.com/983661
    var _color = +('0x' + hexstring.slice(1).replace(hexstring.length < 5 && /./g, '$&$&'));
    r = _color >> 16;
    g = _color >> 8 & 255;
    b = _color & 255;
  } else {
    var nameToHex = colourNameToHex(hexstring);
    if (nameToHex !== null) {
      return getContrast(nameToHex);
    }
    r = 0;
    g = 0;
    b = 0;
  }
  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  var hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
  // return colors.modes.light.text;
  // Using the HSP value, determine whether the color is light or dark
  var mode = hsp > 127.5 ? 'light' : 'dark';
  if (!(colors != null && colors.modes)) {
    return mode === 'light' ? '#000' : '#FFF';
  }
  return colors.modes[mode].text;
};
var contrastTransform = function contrastTransform(scale, n) {
  return [getContrast(get(scale, n, n), scale), get(scale, n, n)];
};

var config$8 = {
  backgroundColor: {
    property: 'backgroundColor',
    scale: 'colors'
  },
  color: {
    property: 'color',
    scale: 'colors'
  },
  opacity: {
    property: 'opacity'
  },
  bg: {
    properties: ['color', 'backgroundColor'],
    scale: 'colors',
    transform: contrastTransform
  }
};
config$8.bgColor = config$8.backgroundColor;
var color = /*#__PURE__*/system(config$8);

var config$7 = {
  alignItems: {
    property: 'alignItems'
  },
  alignContent: {
    property: 'alignContent'
  },
  justifyItems: {
    property: 'justifyItems'
  },
  justifyContent: {
    property: 'justifyContent'
  },
  flexWrap: {
    property: 'flexWrap'
  },
  flexDirection: {
    property: 'flexDirection'
  },
  flex: {
    property: 'flex'
  },
  flexFlow: {
    property: 'flexFlow'
  },
  flexGrow: {
    property: 'flexGrow'
  },
  flexShrink: {
    property: 'flexShrink'
  },
  flexBasis: {
    property: 'flexBasis',
    scale: 'sizes'
  },
  justifySelf: {
    property: 'justifySelf'
  },
  alignSelf: {
    property: 'alignSelf'
  },
  order: {
    property: 'order'
  },
  placeItems: {
    property: 'placeItems'
  },
  placeContent: {
    property: 'placeContent'
  },
  placeSelf: {
    property: 'placeSelf'
  },
  gap: {
    property: 'gap',
    scale: 'sizes'
  }
};
config$7.flexDir = config$7.flexDirection;
var flexbox = /*#__PURE__*/system(config$7);

var config$6 = {
  gridGap: {
    property: 'gridGap',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  gap: {
    property: 'gap',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  gridRowGap: {
    property: 'gridRowGap',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  rowGap: {
    property: 'rowGap',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  gridColumnGap: {
    property: 'gridColumnGap',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  columnGap: {
    property: 'columnGap',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  gridRow: {
    property: 'gridRow'
  },
  gridColumn: {
    property: 'gridColumn'
  },
  gridAutoFlow: {
    property: 'gridAutoFlow'
  },
  gridAutoRows: {
    property: 'gridAutoRows'
  },
  gridAutoColumns: {
    property: 'gridAutoColumns'
  },
  gridTemplateRows: {
    property: 'gridTemplateRows'
  },
  gridTemplateColumns: {
    property: 'gridTemplateColumns'
  },
  gridTemplateAreas: {
    property: 'gridTemplateAreas'
  },
  gridArea: {
    property: 'gridArea'
  }
};
var grid = /*#__PURE__*/system(config$6);

function getWidth(scale, n) {
  return get(scale, n, !isNumber(n) || n > 1 ? n : n * 100 + "%");
}
var config$5 = {
  width: {
    property: 'width',
    scale: 'sizes',
    transform: getWidth
  },
  height: {
    property: 'height',
    scale: 'sizes'
  },
  minWidth: {
    property: 'minWidth',
    scale: 'sizes'
  },
  maxWidth: {
    property: 'maxWidth',
    scale: 'sizes'
  },
  minHeight: {
    property: 'minHeight',
    scale: 'sizes'
  },
  maxHeight: {
    property: 'maxHeight',
    scale: 'sizes'
  },
  display: {
    property: 'display'
  },
  size: {
    properties: ['width', 'height'],
    scale: 'sizes'
  },
  verticalAlign: {
    property: 'verticalAlign'
  },
  overflow: {
    property: 'overflow'
  },
  overflowX: {
    property: 'overflowX'
  },
  overflowY: {
    property: 'overflowY'
  }
};
config$5.w = config$5.width;
config$5.h = config$5.height;
config$5.minW = config$5.minWidth;
config$5.maxW = config$5.maxWidth;
config$5.minH = config$5.minHeight;
config$5.maxH = config$5.maxHeight;
config$5.d = config$5.display;
var layout = /*#__PURE__*/system(config$5);

var config$4 = {
  appearance: {
    property: 'appearance'
  },
  transform: {
    property: 'transform'
  },
  transformOrigin: {
    property: 'transformOrigin'
  },
  visibility: {
    property: 'visibility'
  },
  userSelect: {
    property: 'userSelect'
  },
  pointerEvents: {
    property: 'pointerEvents'
  },
  overflowWrap: {
    property: 'overflowWrap'
  },
  boxSizing: {
    property: 'boxSizing'
  },
  cursor: {
    property: 'cursor'
  },
  resize: {
    property: 'resize'
  },
  objectFit: {
    property: 'objectFit'
  },
  objectPosition: {
    property: 'objectPosition'
  },
  "float": {
    property: 'float'
  },
  fill: {
    property: 'fill',
    scale: 'colors'
  },
  stroke: {
    property: 'stroke',
    scale: 'colors'
  },
  outline: {
    property: 'outline'
  },
  outlineColor: {
    property: 'outlineColor',
    scale: 'colors'
  }
};
var other = /*#__PURE__*/system(config$4);

var config$3 = {
  position: {
    property: 'position'
  },
  zIndex: {
    property: 'zIndex',
    scale: 'zIndices'
  },
  top: {
    property: 'top',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  right: {
    property: 'right',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  bottom: {
    property: 'bottom',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  left: {
    property: 'left',
    scale: 'space',
    defaultScale: defaultTheme.space
  }
};
config$3.pos = config$3.position;
var position = /*#__PURE__*/system(config$3);

var config$2 = {
  boxShadow: {
    property: 'boxShadow',
    scale: 'shadows'
  },
  textShadow: {
    property: 'textShadow',
    scale: 'shadows'
  }
};
var shadow = /*#__PURE__*/system(config$2);

function getMargin(scale, n) {
  if (!isNumber(n)) {
    return get(scale, n, n);
  }
  var isNegative = n < 0;
  var absolute = Math.abs(n);
  var value = get(scale, absolute, n);
  if (!isNumber(value)) {
    return isNegative ? "-" + value : value;
  }
  return value * (isNegative ? -1 : 1);
}
var marginConfig = {
  margin: {
    property: 'margin',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  marginTop: {
    property: 'marginTop',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  marginRight: {
    property: 'marginRight',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  marginBlockStart: {
    property: 'marginBlockStart',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  marginBlockEnd: {
    property: 'marginBlockEnd',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  marginInlineStart: {
    property: 'marginInlineStart',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  marginInlineEnd: {
    property: 'marginInlineEnd',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  }
};
marginConfig.m = marginConfig.margin;
marginConfig.mt = marginConfig.marginTop;
marginConfig.mr = marginConfig.marginRight;
marginConfig.mb = marginConfig.marginBottom;
marginConfig.ml = marginConfig.marginLeft;
marginConfig.mx = marginConfig.marginX;
marginConfig.my = marginConfig.marginY;
marginConfig.marginStart = marginConfig.marginInlineStart;
marginConfig.ms = marginConfig.marginInlineStart;
marginConfig.marginEnd = marginConfig.marginInlineEnd;
marginConfig.me = marginConfig.marginInlineEnd;
var margin = /*#__PURE__*/system(marginConfig);
var paddingConfig = {
  padding: {
    property: 'padding',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  paddingTop: {
    property: 'paddingTop',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  paddingRight: {
    property: 'paddingRight',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  paddingBottom: {
    property: 'paddingBottom',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  paddingLeft: {
    property: 'paddingLeft',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  paddingX: {
    properties: ['paddingLeft', 'paddingRight'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  paddingY: {
    properties: ['paddingTop', 'paddingBottom'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  paddingBlockStart: {
    property: 'paddingBlockStart',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  paddingBlockEnd: {
    property: 'paddingBlockEnd',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  paddingInlineStart: {
    property: 'paddingInlineStart',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  paddingInlineEnd: {
    property: 'paddingInlineEnd',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  }
};
paddingConfig.p = paddingConfig.padding;
paddingConfig.pt = paddingConfig.paddingTop;
paddingConfig.pr = paddingConfig.paddingRight;
paddingConfig.pb = paddingConfig.paddingBottom;
paddingConfig.pl = paddingConfig.paddingLeft;
paddingConfig.px = paddingConfig.paddingX;
paddingConfig.py = paddingConfig.paddingY;
paddingConfig.paddingStart = paddingConfig.paddingInlineStart;
paddingConfig.ps = paddingConfig.paddingInlineStart;
paddingConfig.paddingEnd = paddingConfig.paddingInlineEnd;
paddingConfig.pe = paddingConfig.paddingInlineEnd;
var padding = /*#__PURE__*/system(paddingConfig);
var space = /*#__PURE__*/compose(margin, padding);

var config$1 = {
  transition: {
    property: 'transition',
    scale: 'transition.transition'
  },
  transitionProperty: {
    property: 'transitionProperty',
    scale: 'transition.property'
  },
  transitionDuration: {
    property: 'transitionDuration',
    scale: 'transition.duration'
  },
  transitionTiming: {
    property: 'transitionTimingFunction',
    scale: 'transition.timingFn'
  },
  transitionDelay: {
    property: 'transitionDelay',
    scale: 'transition.delay'
  }
};
var transition = /*#__PURE__*/system(config$1);

var config = {
  fontFamily: {
    property: 'fontFamily',
    scale: 'fonts'
  },
  fontSize: {
    property: 'fontSize',
    scale: 'fontSizes',
    defaultScale: defaultTheme.fontSizes
  },
  fontStyle: {
    property: 'fontStyle'
  },
  fontWeight: {
    property: 'fontWeight',
    scale: 'fontWeights'
  },
  letterSpacing: {
    property: 'letterSpacing',
    scale: 'letterSpacings'
  },
  lineHeight: {
    property: 'lineHeight',
    scale: 'lineHeights'
  },
  textAlign: {
    property: 'textAlign'
  },
  textDecoration: {
    property: 'textDecoration'
  },
  textOverflow: {
    property: 'textOverflow'
  },
  textTransform: {
    property: 'textTransform'
  },
  whiteSpace: {
    property: 'whiteSpace'
  },
  wordBreak: {
    property: 'wordBreak'
  }
};
var typography = /*#__PURE__*/system(config);

var all = /*#__PURE__*/compose(animation, background, border, color, flexbox, grid, layout, other, position, shadow, space, transition, typography);
function getParserDicts() {
  var aliases = {};
  var multiples = {};
  var scales = {};
  var transforms = {};
  all.propNames.forEach(function (propName) {
    var _config$transform;
    var config = all.config[propName];
    if (!config) {
      return;
    }
    if (config.properties) {
      multiples[propName] = [].concat(config.properties);
    }
    if (config.transform && ((_config$transform = config.transform) == null ? void 0 : _config$transform.name) !== 'getValue') {
      transforms[propName] = config.transform;
    }
    if (config.scale) {
      scales[propName] = config.scale;
    }
    if (config.property && propName !== config.property) {
      aliases[propName] = config.property;
    }
  });
  return {
    aliases: aliases,
    multiples: multiples,
    scales: scales,
    transforms: transforms
  };
}

var _getParserDicts = /*#__PURE__*/getParserDicts(),
  aliases = _getParserDicts.aliases,
  multiples = _getParserDicts.multiples,
  scales = _getParserDicts.scales,
  transforms = _getParserDicts.transforms;
function responsive(styles) {
  if (styles === void 0) {
    styles = {};
  }
  return function (theme) {
    var result = {};
    var breakpoints = get(theme, 'breakpoints', defaultBreakpoints);
    var mediaQueries = [null].concat(breakpoints.map(function (n) {
      return "@media screen and (min-width: " + n + ")";
    }));
    if (!styles) return result;
    Object.keys(styles).forEach(function (key) {
      var value = isFunction(styles[key]) ? styles[key](theme) : styles[key];
      if (value === null) {
        return;
      }
      if (!Array.isArray(value)) {
        result[key] = value;
        return;
      }
      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i += 1) {
        var media = mediaQueries[i];
        if (!media) {
          result[key] = value[i];
          continue;
        }
        result[media] = result[media] || {};
        if (value[i] == null) {
          continue;
        }
        result[media][key] = value[i];
      }
    });
    return result;
  };
}
function css(args) {
  return function (props) {
    // const propsTheme = ((props ?? { theme: props }) as { theme: Theme }).theme;
    var theme = _extends({}, defaultTheme);
    if (isTheme(props)) {
      theme = _extends({}, theme, props.theme);
    } else {
      theme = _extends({}, theme, props);
    }
    var result = {};
    var obj = typeof args === 'function' ? args(theme) : args;
    var styles = responsive(obj)(theme);
    Object.keys(styles).forEach(function (key) {
      var x = styles[key];
      var val = isFunction(x) ? x(theme) : x;
      if (val && typeof val === 'object') {
        if (Object.keys(pseudoSelectors).includes(key)) {
          result[pseudoSelectors[key].join(', ')] = css(val)(theme);
          return;
        }
        result[key] = css(val)(theme);
        return;
      }
      var prop = get(aliases, key, key);
      var scaleName = get(scales, prop);
      var scale = get(theme, scaleName, get(theme, prop, {}));
      var transform = get(transforms, prop, get);
      var value;
      // when the val is a number and less than 0, resolve it from the theme
      // using its absolute value and then make the result a negative.
      // otherwise, just resolve the value.
      if (typeof val === 'number' && val < 0) {
        var abs = Math.abs(val);
        var n = transform(scale, abs, abs);
        value = typeof n === 'string' ? "-" + n : n * -1;
      } else {
        value = transform(scale, val, val);
      }
      if (multiples[prop]) {
        var dirs = multiples[prop];
        for (var i = 0; i < Object.keys(dirs).length; i += 1) {
          if (Array.isArray(value)) {
            result[dirs[i]] = value[i];
          } else {
            result[dirs[i]] = value;
          }
        }
        return;
      } else {
        result[prop] = value;
      }
    });
    return result;
  };
}

var extendedConfig$1 = {
  align: {
    property: 'alignItems'
  },
  justify: {
    property: 'justifyContent'
  },
  wrap: {
    property: 'flexWrap'
  },
  direction: {
    property: 'flexDirection'
  }
};
var extendedFlexbox = /*#__PURE__*/compose(flexbox, /*#__PURE__*/system(extendedConfig$1));

var extendedConfig = {
  row: {
    property: 'gridRow'
  },
  column: {
    property: 'gridColumn'
  },
  autoFlow: {
    property: 'gridAutoFlow'
  },
  autoRows: {
    property: 'gridAutoRows'
  },
  autoColumns: {
    property: 'gridAutoColumns'
  },
  templateRows: {
    property: 'gridTemplateRows'
  },
  templateColumns: {
    property: 'gridTemplateColumns'
  },
  templateAreas: {
    property: 'gridTemplateAreas'
  },
  area: {
    property: 'gridArea'
  }
};
var extendedGrid = /*#__PURE__*/compose(grid, /*#__PURE__*/system(extendedConfig));

var allConfig = /*#__PURE__*/compose(animation, background, border, color, extendedFlexbox, extendedGrid, flexbox, grid, layout, other, position, shadow, space, transition, typography);
var createPseudoValue = function createPseudoValue(property) {
  return function (value, path, props) {
    var result = {};
    var properties = pseudoSelectors[property];
    if (props != null && props[property]) {
      result[properties.join(', ')] = allConfig(_extends({
        theme: props.theme
      }, props[property]));
    }
    return result;
  };
};
var pseudo = function pseudo(props) {
  var config = {
    _active: createPseudoValue('_active'),
    _activeLink: createPseudoValue('_activeLink'),
    _after: createPseudoValue('_after'),
    _before: createPseudoValue('_before'),
    _checked: createPseudoValue('_checked'),
    _empty: createPseudoValue('_empty'),
    _even: createPseudoValue('_even'),
    _expanded: createPseudoValue('_expanded'),
    _first: createPseudoValue('_first'),
    _focus: createPseudoValue('_focus'),
    _focusVisible: createPseudoValue('_focusVisible'),
    _focusWithin: createPseudoValue('_focusWithin'),
    _fullScreen: createPseudoValue('_fullScreen'),
    _grabbed: createPseudoValue('_grabbed'),
    _hidden: createPseudoValue('_hidden'),
    _highlighted: createPseudoValue('_highlighted'),
    _indeterminate: createPseudoValue('_indeterminate'),
    _invalid: createPseudoValue('_invalid'),
    _last: createPseudoValue('_last'),
    _loading: createPseudoValue('_loading'),
    _notFirst: createPseudoValue('_notFirst'),
    _notLast: createPseudoValue('_notLast'),
    _odd: createPseudoValue('_odd'),
    _placeholder: createPseudoValue('_placeholder'),
    _pressed: createPseudoValue('_pressed'),
    _readOnly: createPseudoValue('_readOnly'),
    _selected: createPseudoValue('_selected'),
    _selection: createPseudoValue('_selection'),
    _valid: createPseudoValue('_valid'),
    _visited: createPseudoValue('_visited'),
    _hover: createPseudoValue('_hover'),
    _disabled: createPseudoValue('_disabled')
  };
  return createParser(config)(props);
};

var variant = function variant(_ref) {
  var _createParser;
  var _ref$prop = _ref.prop,
    prop = _ref$prop === void 0 ? 'variant' : _ref$prop,
    key = _ref.key;
  var sx = function sx(value, scale, props) {
    return css(get(scale, value, null))(props.theme);
  };
  sx.scale = key ? key.includes('defaultStyles') ? key : "variants." + key : "variants";
  sx.defaults = {};
  return createParser((_createParser = {}, _createParser[prop] = sx, _createParser));
};
var ButtonVariants = /*#__PURE__*/variant({
  key: 'buttons'
});
var TextVariants = /*#__PURE__*/variant({
  key: 'text',
  prop: 'text'
});
var IntentVariants = /*#__PURE__*/variant({
  key: 'intents',
  prop: 'intent'
});
var defaultStyles = /*#__PURE__*/variant({
  key: 'defaultStyles',
  prop: 'defaultStyles'
});

export { ButtonVariants, IntentVariants, TextVariants, animation, background, border, color, compose, contrastTransform, createParser, createStyleFunction, css, defaultStyles, extendedFlexbox, extendedGrid, flexbox, get, getContrast, grid, layout, other, position, pseudo, shadow, space, system, transition, typography, variant };
//# sourceMappingURL=styled-system.esm.js.map
